import {InnerSection} from '../InnerSection'
import {Container} from './components/Container'
import {HeroLeft} from './components/HeroLeft'
import {Left} from './components/Left'

export const HeroUnit = () => (
  <Container>
    <InnerSection>
      <HeroLeft />
      <Left />
    </InnerSection>
  </Container>
)
